import React, { useRef, useState } from 'react'

import { Button } from "primereact/button"

import { AiOutlineMenu } from "react-icons/ai"
import {  MdArrowDropDown } from "react-icons/md"
import { GrLogout } from "react-icons/gr"

import styles from "./AdminNavbar.module.css"

import { RootContext } from '../../../context/RootProvider'
import { useContext } from 'react'

import { useNavigate } from 'react-router-dom'

import { downloadCVs } from '../../../utils/apiCalls'

import  download  from 'downloadjs' 

import { Link, NavLink } from 'react-router-dom'

import {Toaster, toast} from "react-hot-toast"


import { FaSignOutAlt, FaFileDownload, FaPen, FaUserCircle, FaLongArrowAltLeft, FaCalendarAlt, FaBars, FaDownload } from "react-icons/fa";

function AdminNavbar({ showMenu, setShowMenu }) {
    const [showDownloadCVs, setShowDownloadCVs] = useState(false)

    const resumeRef = useRef()

    const rootContext = useContext(RootContext);

    const navigate = useNavigate()

    function handleLogout(){
        rootContext.setUser(null)
        rootContext.setIsUserAdmin(false)
        
        navigate("/")
    }

     function toggleHamburger(){
    if(showMenu) setShowMenu(false);
    else setShowMenu(true);
  }

    function changeMenuVisibility(){
        setShowMenu(!showMenu)
    }

    function toggleDownloadArea(){
        setShowDownloadCVs(!showDownloadCVs)
    }

    async function handleDownloadCVs(){
      toast("Se pregătește descărcarea. Acest proces poate dura câteva minute");
        const fileBlob = await downloadCVs()
        download(fileBlob, "CVs.zip", "application/zip")
        toast("CV-urile au fost descărcate");
    }

  return (
    <>
    <div className={styles.navContainer}>
        <div className={styles.hamburger}>
                <button id="deschideHamburger" className={styles.hamburgerButton} onClick={() => toggleHamburger()}> {showMenu ? <span className={styles.icon}>X</span> : <FaBars className={styles.icon}></FaBars>}</button>
              </div>
              <div className={styles.navbar}>
                    <NavLink to="/admin/home"
                    className={({isActive}) => isActive ? `${styles.navItem} ${styles.onHover} ${styles.active}` : `${styles.navItem} ${styles.onHover}`}
                    >
                      <FaUserCircle className={styles.icon}></FaUserCircle>
                      Utilizatori înscriși
                    </NavLink>
              
              
                            <NavLink to="/admin/view-booked" className={({isActive}) => isActive ? `${styles.navItem} ${styles.onHover} ${styles.active}` : `${styles.navItem} ${styles.onHover}`}>
                                <FaCalendarAlt className={styles.icon2} />
                              Interviuri programate
                            </NavLink>
              
                    {/* <div className={styles.logoContainer}>
                      <img className={styles.logo} src={Logo} alt="ttj" />
                      <div className={styles.icon}></div>
                    </div> */}
              
                           <NavLink to="/admin/create-interview" className={({isActive}) => isActive ? `${styles.navItem} ${styles.onHover} ${styles.active}` : `${styles.navItem} ${styles.onHover}`}>
                                <FaPen className={styles.icon2} />
                              Creează / modifică interviu
                            </NavLink>

                            <button onClick={() => handleDownloadCVs()} className={`${styles.navItem} ${styles.onHover}`}>
                                <FaFileDownload className={styles.icon2}/>
                                Descarcă CV-urile participanților
                            </button>
              
                    <div
                      onClick={handleLogout}
                      className={`${styles.navItem} ${styles.onHover}`}
                    >
                      <FaSignOutAlt className={styles.icon}></FaSignOutAlt>
                      <p>Logout</p>
                    </div>
                    </div>
        {/* <div className={styles.container}>
            <AiOutlineMenu onClick={changeMenuVisibility} size={30} cursor="pointer" />
            <p className={styles.content}>Dashboard</p>
        </div> */}

        {/* <div className={styles.container}>
            <div className={styles.resume}>
                <div onClick={toggleDownloadArea} className={`${styles.container} ${styles.onHover}`}>
                    <p ref={resumeRef}>Resumes</p>
                    <MdArrowDropDown size={24} />
                </div>

                <div className={`${showDownloadCVs === true ? styles.downloadArea : styles.hideDownloadArea}`}>
                    <Button onClick={handleDownloadCVs} label="Download CVs" icon="pi pi-download" iconPos="right" />
                </div>
            </div>

            <div onClick={handleLogout} className={`${styles.container} ${styles.logout} ${styles.onHover}`}>
                <GrLogout size={30} />
                <p>Logout</p>
            </div>
        </div> */}
    </div>
    <Toaster/>
    </>
  )
}

export default AdminNavbar